module.exports = __webpack_public_path__ + "img/EHLLogo.72024886.svg";